import { all, call, put, takeLatest } from "redux-saga/effects";

import {
  getEducationInformationStart,
  getEducationInformationSuccess,
  getEducationInformationFailed,
} from "../redux/getEducationInformation";

import { getEducationInformationApi } from "core/http/service/personnelInformation";
import { resetFormEditEductionInformation } from "../redux/formEditEducationInformation";
import moment from "moment";

function* getEducationInformationWork() {
  try {
    const res = yield call(getEducationInformationApi);
    yield put({
      type: getEducationInformationSuccess.type,
      payload:
        res?.map((it) => ({
          ...it,
          graduationYear: it.graduationYear ? moment(it.graduationYear) : null,
        })) || [],
    });

    yield put({
      type: resetFormEditEductionInformation.type,
    });
  } catch (error: any) {
    yield put({
      type: getEducationInformationFailed.type,
    });
  }
}

function* watchGetEducationInformation() {
  yield takeLatest(
    getEducationInformationStart.type,
    getEducationInformationWork
  );
}

export default function* getEducationInformationSaga() {
  yield all([watchGetEducationInformation()]);
}
